export class PaginationOptionsModel {
    public queryKey: string = "pageNumber";
    public buttonsCount: number = 5;
    public showGoToFirst: boolean = true;
    public showGoToLast: boolean = true;
    public showGoToPrevious: boolean = true;
    public showGoToNext: boolean = true;
    public showSkipLabel: boolean = true;
    public labelFirst: string = "First";
    public labelLast: string = "Last";
    public labelPrevious: string = "Previous page";
    public labelNext: string = "Next page";
    public labelSkip: string = "...";
}
